<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '../ui-utils.ts';

const props = defineProps<{
  class?: HTMLAttributes['class'];
}>();
</script>

<template>
  <caption :class="cn('mt-4 text-sm text-slate-500', props.class)">
    <slot />
  </caption>
</template>
